(() => {
  const desktopHover = window.matchMedia(
    '(min-width: 990px) and (hover: hover) and (pointer: fine)'
  );

  function initWavyHoverMenu() {
    const menus = document.querySelectorAll(
      '.header__inline-menu header-menu > details'
    );

    menus.forEach((details) => {
      if (details.dataset.wavyHoverInit === 'true') return;

      const summary = details.querySelector(':scope > summary');
      if (!summary) return;

      details.dataset.wavyHoverInit = 'true';

      let closeTimer;

      const openMenu = () => {
        if (!desktopHover.matches) return;

        clearTimeout(closeTimer);

        menus.forEach((other) => {
          if (other !== details && other.open) {
            other.open = false;

            const otherSummary = other.querySelector(':scope > summary');
            if (otherSummary) {
              otherSummary.setAttribute('aria-expanded', 'false');
            }
          }
        });

        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
      };

      const closeMenu = () => {
        if (!desktopHover.matches) return;

        clearTimeout(closeTimer);

        closeTimer = setTimeout(() => {
          details.open = false;
          summary.setAttribute('aria-expanded', 'false');
        }, 150);
      };

      details.addEventListener('mouseenter', openMenu);
      details.addEventListener('mouseleave', closeMenu);

      details.addEventListener('focusin', () => {
        clearTimeout(closeTimer);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWavyHoverMenu);
  } else {
    initWavyHoverMenu();
  }

  document.addEventListener('shopify:section:load', initWavyHoverMenu);
})();